export const categories = [
  { slug: 'romance', name: '恋爱浪漫', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', count: 96 },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line', count: 85 },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', count: 73 },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 62 },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', count: 41 },
  { slug: 'historical', name: '古风历史', icon: 'ri-ancient-gate-line', count: 38 },
  { slug: 'slice-of-life', name: '治愈日常', icon: 'ri-cup-line', count: 55 },
];

export const featuredComics = [
  {
    id: 1,
    slug: 'goddess-descends',
    title: '女神降临',
    altTitle: 'True Beauty',
    author: '喵喵',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%2C%20soft%20romantic%20portrait%2C%20pastel%20pink%20and%20cream%20background%2C%20minimalist%20composition%2C%20delicate%20features%2C%20dreamy%20atmosphere%2C%20clean%20lines%2C%20soft%20lighting%2C%20editorial%20quality%2C%20no%20text&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 4.9,
    views: '320万',
    chapters: 186,
    status: '连载中',
    description: '因为外貌被欺凌的女高中生，通过化妆技巧华丽变身，从此开启了完全不同的人生。校园女神背后隐藏着不为人知的秘密...',
    tags: ['恋爱', '校园', '逆袭', '治愈'],
    updatedAt: '2026-07-02',
  },
  {
    id: 2,
    slug: 'solo-leveling',
    title: '我独自升级',
    altTitle: 'Solo Leveling',
    author: 'Chugong',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20armor%2C%20glowing%20purple%20eyes%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20background%20with%20shadows%2C%20epic%20fantasy%20vibe%2C%20clean%20art%20style%2C%20no%20text&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 4.9,
    views: '890万',
    chapters: 200,
    status: '已完结',
    description: '被称为"人类最弱"的猎人成振宇，在经历了生死考验后获得了"系统"的能力，从此踏上成为最强猎人的征途。',
    tags: ['热血', '奇幻', '战斗', '升级'],
    updatedAt: '2026-07-01',
  },
  {
    id: 3,
    slug: 'omniscient-reader',
    title: '全知读者视角',
    altTitle: 'Omniscient Reader',
    author: 'sing N song',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20white%20coat%20holding%20a%20book%2C%20apocalyptic%20fantasy%20background%20with%20subtle%20constellation%20patterns%2C%20mysterious%20and%20intellectual%20atmosphere%2C%20clean%20art%20style%2C%20dramatic%20lighting%2C%20no%20text&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 4.8,
    views: '560万',
    chapters: 210,
    status: '连载中',
    description: '唯一读完那本没人看的小说的人，当小说世界变成现实，他凭借着对全部剧情的了解，开始了在末日世界中的生存之旅。',
    tags: ['奇幻', '末世', '策略', '悬疑'],
    updatedAt: '2026-07-03',
  },
  {
    id: 4,
    slug: 'return-of-blade-master',
    title: '剑尊归来',
    altTitle: 'Return of the Blade Master',
    author: 'LICO',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20style%20illustration%20of%20a%20swordsman%20with%20flowing%20long%20hair%20in%20traditional%20eastern%20robe%2C%20holding%20a%20gleaming%20sword%2C%20misty%20mountain%20background%2C%20elegant%20dynamic%20pose%2C%20ink%20wash%20aesthetic%2C%20clean%20art%2C%20no%20text&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 4.7,
    views: '430万',
    chapters: 156,
    status: '连载中',
    description: '曾经天下无敌的剑尊被亲信背叛陨落，百年后重生归来。这次他不会再重蹈覆辙，誓要重登巅峰。',
    tags: ['武侠', '重生', '复仇', '热血'],
    updatedAt: '2026-07-02',
  },
  {
    id: 5,
    slug: 'who-made-me-princess',
    title: '某天成为公主',
    altTitle: 'Who Made Me a Princess',
    author: 'Plutus',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20young%20princess%20with%20blonde%20hair%20and%20blue%20eyes%20in%20an%20elegant%20gown%2C%20royal%20palace%20garden%20background%20with%20roses%2C%20soft%20dreamy%20lighting%2C%20fairy%20tale%20atmosphere%2C%20clean%20art%20style%2C%20no%20text&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 4.8,
    views: '510万',
    chapters: 175,
    status: '连载中',
    description: '意外穿越成为小说中的小公主，为了不被亲生父皇所杀，她必须用尽一切手段博取那位冷酷父皇的欢心。',
    tags: ['穿越', '宫廷', '亲情', '治愈'],
    updatedAt: '2026-07-01',
  },
  {
    id: 6,
    slug: 'villainess-survival',
    title: '反派千金的生存法则',
    altTitle: 'The Villainess Survival Guide',
    author: 'Gwon Gyeoeul',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20an%20elegant%20noblewoman%20with%20dark%20red%20hair%20in%20a%20luxurious%20gown%2C%20confident%20expression%2C%20palace%20interior%20background%20with%20chandeliers%2C%20dramatic%20and%20opulent%20atmosphere%2C%20clean%20art%20style%2C%20no%20text&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 4.6,
    views: '280万',
    chapters: 98,
    status: '连载中',
    description: '穿越为注定悲惨结局的反派千金，她决定改写命运。既然要当反派，那就当最闪耀的那个。',
    tags: ['穿越', '逆袭', '宫廷', '女强'],
    updatedAt: '2026-06-30',
  },
];

export const latestComics = [
  { id: 7, slug: 'remarried-empress', title: '再婚皇后', category: 'romance', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20romance%20illustration%20of%20a%20graceful%20queen%20in%20an%20ornate%20crown%20and%20elegant%20dress%2C%20palace%20throne%20room%20background%2C%20regal%20and%20dignified%20atmosphere%2C%20soft%20golden%20lighting%2C%20clean%20art%20style%2C%20no%20text&width=400&height=560&seq=comic-latest-01&orientation=portrait', rating: 4.7, chapters: 142, status: '连载中' },
  { id: 8, slug: 'sweet-trap', title: '甜蜜的陷阱', category: 'drama', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20illustration%20of%20a%20stylish%20young%20woman%20in%20modern%20business%20attire%2C%20cityscape%20background%20through%20window%2C%20sophisticated%20and%20chic%20atmosphere%2C%20warm%20evening%20lighting%2C%20clean%20art%20style%2C%20no%20text&width=400&height=560&seq=comic-latest-02&orientation=portrait', rating: 4.5, chapters: 87, status: '连载中' },
  { id: 9, slug: 'dukes-contract-fiancee', title: '公爵的契约未婚妻', category: 'romance', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20illustration%20of%20a%20couple%20in%20elegant%20noble%20attire%20standing%20together%2C%20grand%20duke%20mansion%20background%2C%20romantic%20yet%20mysterious%20atmosphere%2C%20soft%20candlelight%20glow%2C%20clean%20art%20style%2C%20no%20text&width=400&height=560&seq=comic-latest-03&orientation=portrait', rating: 4.8, chapters: 120, status: '连载中' },
  { id: 10, slug: 'definition-of-evil', title: '恶女的定义', category: 'drama', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dramatic%20illustration%20of%20a%20cold%20beautiful%20woman%20with%20sharp%20eyes%20in%20dark%20elegant%20clothing%2C%20high%20society%20party%20background%2C%20intense%20and%20sophisticated%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20art%20style%2C%20no%20text&width=400&height=560&seq=comic-latest-04&orientation=portrait', rating: 4.4, chapters: 65, status: '连载中' },
  { id: 11, slug: 'heavenly-demon-cultivation', title: '天魔养成记', category: 'action', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20fantasy%20illustration%20of%20a%20young%20martial%20artist%20with%20dark%20energy%20aura%2C%20ancient%20eastern%20temple%20background%2C%20mysterious%20and%20powerful%20atmosphere%2C%20dramatic%20moonlight%2C%20clean%20art%20style%2C%20no%20text&width=400&height=560&seq=comic-latest-05&orientation=portrait', rating: 4.6, chapters: 134, status: '连载中' },
  { id: 12, slug: 'seoul-station-necromancer', title: '首尔站死灵法师', category: 'fantasy', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20fantasy%20illustration%20of%20a%20dark%20mage%20in%20modern%20clothing%20with%20supernatural%20energy%2C%20Seoul%20cityscape%20at%20night%20background%2C%20dark%20and%20mysterious%20atmosphere%2C%20neon%20lights%2C%20clean%20art%20style%2C%20no%20text&width=400&height=560&seq=comic-latest-06&orientation=portrait', rating: 4.7, chapters: 178, status: '已完结' },
];

export const rankingComics = [
  { rank: 1, title: '我独自升级', slug: 'solo-leveling', views: '890万', rating: 4.9 },
  { rank: 2, title: '全知读者视角', slug: 'omniscient-reader', views: '560万', rating: 4.8 },
  { rank: 3, title: '某天成为公主', slug: 'who-made-me-princess', views: '510万', rating: 4.8 },
  { rank: 4, title: '女神降临', slug: 'goddess-descends', views: '320万', rating: 4.9 },
  { rank: 5, title: '剑尊归来', slug: 'return-of-blade-master', views: '430万', rating: 4.7 },
  { rank: 6, title: '再婚皇后', slug: 'remarried-empress', views: '380万', rating: 4.7 },
  { rank: 7, title: '首尔站死灵法师', slug: 'seoul-station-necromancer', views: '350万', rating: 4.7 },
  { rank: 8, title: '公爵的契约未婚妻', slug: 'dukes-contract-fiancee', views: '290万', rating: 4.8 },
];